// src/utils/roleHelper.js
export const getRoleFromRoleId = (roleId) => {
  const roleMap = {
    1: "Adminstrateur",
    2: "Judo Starter",
    3: "Judo Expert",
    5: "Coach",
    6: "Coach Pro",
    7: "Coach Ultim",
  };
  return roleMap[roleId] || "user"; // Fallback à 'user' si `roleId` est inconnu
};


export const checkRoleAccess = (userRoleId, allowedRoles) => {
  if (!Array.isArray(allowedRoles)) {
    console.error("allowedRoles n'est pas un tableau :", allowedRoles);
    return false;
  }
  return allowedRoles.includes(userRoleId);
};